module.exports = __webpack_public_path__ + "7c43f2adb8bbf6e8c1d6422e4ccca948.jpg";